// src/views/Errors/ErrorItem/ErrorItem.tsx
import { Flex, Text } from "@chakra-ui/react";
import { Info } from "@airhelp/icons";
import { InfoBox } from "@airhelp/info-box";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var ErrorItem = ({ message, fileName, genericMessage }) => /* @__PURE__ */ jsx(InfoBox, {
  variant: "danger",
  icon: /* @__PURE__ */ jsx(Info, {
    color: "danger.500",
    boxSize: 5
  }),
  w: "100%",
  gap: 2,
  alignItems: "center",
  children: /* @__PURE__ */ jsx(Flex, {
    direction: "column",
    justify: "center",
    children: genericMessage ? /* @__PURE__ */ jsx(Text, {
      fontSize: "sm",
      color: "greyscale.800",
      wordBreak: "break-all",
      children: genericMessage
    }) : /* @__PURE__ */ jsxs(Fragment, {
      children: [
        /* @__PURE__ */ jsx(Text, {
          fontSize: "sm",
          color: "greyscale.800",
          wordBreak: "break-all",
          children: fileName
        }),
        /* @__PURE__ */ jsx(Text, {
          fontSize: "sm",
          color: "greyscale.800",
          fontWeight: "medium",
          wordBreak: "break-all",
          children: message
        })
      ]
    })
  })
});

export {
  ErrorItem
};
